import { useCallback } from 'react';

import {
    TGames
} from '@interlayer/js/app/components/main/Games/components/GameCategory/components/GameList/hooks/useGetBingoSchedule/types';
import { useCurrentFormFactor } from '@interlayer/js/app/hooks/device/hooks/useMediaQuery';
import { useConfigTag } from '@interlayer/js/app/hooks/useConfigTag';
import { CONFIG_TAG_TYPE } from '@interlayer/js/components/system/TagManager/buzz/constants';
import { TAppPinnedGamesTagConfig } from '@interlayer/js/components/system/TagManager/buzz/types';

export const useGetPinnedGames = () => {
    const currentFormFactor = useCurrentFormFactor();
    const pinnedGamesTags = useConfigTag(CONFIG_TAG_TYPE.pinningGames, true) as TAppPinnedGamesTagConfig[];

    return useCallback((initialGames: TGames[]) => {
        if (!pinnedGamesTags?.length) {
            return initialGames;
        }

        return pinnedGamesTags.reduce((acc, { config: { games } }) => {
            games.reverse().forEach(({ gameCodes, platform }) => {
                if (platform.includes(currentFormFactor)) {
                    gameCodes.split(',')
                        .reverse()
                        .forEach((item) => {
                            const index = acc.findIndex(({ gameCode }) => gameCode === item.trim());

                            if (index > 0) {
                                acc.splice(0, 0, acc.splice(index, 1)[0]);
                            }
                        });
                }
            });

            return acc;
        }, [...initialGames]);
    }, [currentFormFactor, pinnedGamesTags]);
};
